<template>
  <v-card v-if="invoice">
    <v-card-text class="d-flex align-items-center justify-content-between">
      <div class="text-black font-weight-regular">
        Balance due:
        <strong class="text-red">{{ invoice.balance }}</strong>
      </div>
      <router-link
        :to="`/invoice/${invoice.id}`"
        class="link ml-auto text-decoration-none"
      >
        Invoice #{{ invoice.id }}
      </router-link>
      <div class="divider" />
      <a
        href="#pay"
        class="link text-decoration-none"
        @click.prevent="emit('pay-balance', invoice.id)"
      >
        Pay
      </a>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { Invoice } from "@/typings/invoice";

defineProps({
  invoice: {
    type: Object as () => Invoice,
    default: null
  }
});

const emit = defineEmits(["pay-balance"]);
</script>

<style lang="scss" scoped>
.link {
  color: #276fff;
}
.divider {
  margin-left: 15px;
  margin-right: 15px;
  height: 20px;
  background: #d3d7d9;
  width: 1px;
}
</style>
